export default __webpack_public_path__ + "static/media/books.fa081896.webp";